const ExamCategoryType = {
	None: 0,
	YKS: 1,
	LGS: 2,
	KPSS:3,
	Maarif9:5,
	Maarif10:6,
};

export default ExamCategoryType;